// Создаем новый объект типа Document
export function createHiddenDocument(htmlString) {
  // Создаем новый документ, используя DOMParser
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // Создаем iframe, чтобы документ был изолирован и не отображался
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none'; // Скрываем iframe
  document.body.appendChild(iframe);

  // Вставляем созданный документ в iframe
  const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(htmlString);
  iframeDoc.close();

  return iframeDoc;
}
export function removeHiddenDocument(iframe) {
  if (true) {
    console.log('ыглф');
    let iframes = document.getElementsByTagName('iframe');
    for (let elem of iframes) {
      elem.parentNode.removeChild(elem);
    }

    // iframe.parentNode.removeChild(iframe);
  }
}
export function removeScriptTags(html) {
  // Создаем регулярное выражение для поиска тегов <script>
  var scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;

  // Удаляем все найденные теги <script> и их содержимое
  var cleanedHtml = html.replace(scriptRegex, '');

  // Возвращаем очищенную HTML строку без тегов <script>
  return cleanedHtml;
}

export function cleanScripts() {
  let workspace = document.getElementById('workspace');
  function removeScripts(element) {
    var scripts = element.getElementsByTagName('script');

    // Проходимся по найденным скриптам и удаляем их
    for (var i = scripts.length - 1; i >= 0; i--) {
      scripts[i].parentNode.removeChild(scripts[i]);
    }
  }
  for (let div of workspace.children) {
    removeScripts(div);
  }
}
export function getBackgroundWidgetsValue(htmlString) {
  // Создаем элемент для парсинга HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // Находим все теги <style>
  const styleTags = doc.querySelectorAll('style');
  console.log(doc);
  console.log(styleTags);

  // Проходим по всем <style> тегам и ищем :root
  for (const styleTag of styleTags) {
    const styleContent = styleTag.textContent;
    const regex =
      /--background-widgets:\s*rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*(\d*\.?\d+)?\)\s*(?:!important)?;/;
    const match = styleContent.match(regex);

    if (match) {
      const r = parseInt(match[1], 10);
      const g = parseInt(match[2], 10);
      const b = parseInt(match[3], 10);
      const a = match[4] !== undefined ? parseFloat(match[4]) : 1;

      return {
        rgb: {
          r,
          g,
          b,
          a,
        },
      };
    }
  }

  // Если не найдено
  return null;
}


export function getTextColorValue(htmlString) {
  // Создаем элемент для парсинга HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  // Находим все теги <style>
  const styleTags = doc.querySelectorAll('style');
  console.log(doc);
  console.log(styleTags);

  // Проходим по всем <style> тегам и ищем :root
  for (const styleTag of styleTags) {
    const styleContent = styleTag.textContent;
    const regex =
      /--text-color:\s*rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*(\d*\.?\d+)?\)\s*(?:!important)?;/;
    const match = styleContent.match(regex);

    if (match) {
      const r = parseInt(match[1], 10);
      const g = parseInt(match[2], 10);
      const b = parseInt(match[3], 10);
      const a = match[4] !== undefined ? parseFloat(match[4]) : 1;

      return {
        rgb: {
          r,
          g,
          b,
          a,
        },
      };
    }
  }

  // Если не найдено
  return null;
}
